import { IUser } from '@/dataroom/domain/vo/User';
import { IUserItem } from '@/dataroom/domain/vo/users/UserItem';
import { canManageSettings } from '@/dataroom/domain/managePermissions';
import { IDataroom } from '@/dataroom/domain/vo/Dataroom';

export const isDateModifiedDisabled = (dataroom: IDataroom, user: IUser | IUserItem) => (
  dataroom.dateModifiedDisabled && !canManageSettings(user)
);
